import React, { Fragment } from 'react'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import DatosGeneralesComponent from './DatosGeneralesComponent';
import MediosContactoComponent from './MediosContactoComponent';
import ApoderadosLegalesComponent from './ApoderadosLegalesComponent';
import PersonasAutorizadasComponent from './PersonasAutorizadasComponent';
import { useDispatch, useSelector } from 'react-redux'
import {
    obtenerTodosApoderadosLegalesClientes, obtenerTodosMediosContactoClientes,
    obtenerTodosPersonasAutorizadasClientes, obtenerCliente
} from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';

function TabsDatosGeneralesComponent(props) {

    let detalleCliente = props?.detalle
    const [datosGenerales, setDatosGenerales] = React.useState((detalleCliente?.mediosdecontactocliente?.length == 0 && detalleCliente?.apoderadoslegalescliente?.length == 0) ? 'personasAutorizadas' : detalleCliente?.mediosdecontactocliente?.length == 0 ? 'apoderados' : 'mediosContacto');
    const dispatch = useDispatch()

    const handleChangeDatosGenerales = (event, newValue) => {
        setDatosGenerales(newValue);
    };

    function sortJSON(data, key, orden) {
        // Crea una copia del arreglo usando el operador de propagación (spread operator)
        const dataCopy = [...data];

        return dataCopy.sort(function (a, b) {
            var x = a[key],
                y = b[key];

            if (orden === 'asc') {
                if (x === y) return 0;
                if (x === false) return -1;
                if (y === false) return 1;
                return 0;
            }

            if (orden === 'desc') {
                if (x === y) return 0;
                if (x === true) return -1;
                if (y === true) return 1;
                return 0;
            }
        });
    }

    function ordenarActivosASC(array, idName) {
        let activos = []
        let inactivos = []

        array?.map(item => {
            if (item?.isbaja == false) activos.push(item)
            else if (item?.isbaja == true) inactivos.push(item)
        })

        if (activos.length > 1) {
            if (idName == 'medioscontacto') activos.sort(((a, b) => a.idmediosdecontacto - b.idmediosdecontacto));
            else if (idName == 'apoderadoslegales') activos.sort(((a, b) => a.idapoderadoslegales - b.idapoderadoslegales));
            else if (idName == 'personasautorizadas') activos.sort(((a, b) => a.idrepresentantesautorizados - b.idrepresentantesautorizados));
        }

        return activos.concat(inactivos);
    }

    const [isEdicionCliente, setIsEdicionCliente] = React.useState(false);

    React.useEffect(async () => {
        if (isEdicionCliente) {
            let cliente = await dispatch(obtenerCliente(detalleCliente?.idcliente))
            props?.setCliente(cliente?.payload)
            setIsEdicionCliente(false)
        }
    }, [isEdicionCliente])

    const [mediosContacto, setmediosContacto] = React.useState([]);
    const [isEdicionMedioContacto, setIsEdicionmediosContacto] = React.useState(false);

    React.useEffect(async () => {
        if (datosGenerales == 'mediosContacto') {
            let medios = await dispatch(obtenerTodosMediosContactoClientes(detalleCliente?.idcliente))
            setmediosContacto(medios?.payload)
        }
        setIsEdicionmediosContacto(false)
    }, [datosGenerales, isEdicionMedioContacto])

    const [apoderadosLegales, setApoderadosLegales] = React.useState([]);
    const [isEdicionApoderados, setIsEdicionApoderados] = React.useState(false);

    React.useEffect(async () => {
        if (datosGenerales == 'apoderados') {
            let apoderados = await dispatch(obtenerTodosApoderadosLegalesClientes(detalleCliente?.idcliente))
            setApoderadosLegales(apoderados?.payload)
        }
        setIsEdicionApoderados(false)
    }, [datosGenerales, isEdicionApoderados])

    const [personasAutorizadas, setPersonasAutorizadas] = React.useState([]);
    const [isEdicionPersonas, setIsEdicionPersonas] = React.useState(false);

    React.useEffect(async () => {
        if (datosGenerales == 'personasAutorizadas') {
            let personas = await dispatch(obtenerTodosPersonasAutorizadasClientes(detalleCliente?.idcliente))
            setPersonasAutorizadas(personas?.payload)
        }
        setIsEdicionPersonas(false)
    }, [datosGenerales, isEdicionPersonas])

    return (
        <Fragment>
            <DatosGeneralesComponent data={detalleCliente} cliente={props?.cliente} setIsEdicionCliente={setIsEdicionCliente} />
            {/*tablaDataGrid(rowsPrincipal, columns)*/}
            {(detalleCliente.mediosdecontactocliente?.length > 0 || detalleCliente.apoderadoslegalescliente?.length > 0 || detalleCliente?.representantesautorizadoscliente?.length > 0) &&
                <Box sx={{ width: '100%', typography: 'body1', marginTop: '3%' }}>
                    <TabContext value={datosGenerales}>
                        <Box sx={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            textAlign: 'center', backgroundColor: '#fcfcfc',
                            boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
                        }}>
                            <TabList onChange={handleChangeDatosGenerales} aria-label="lab API tabs example" className='text-center'
                                TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                sx={{
                                    "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
                                    "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                                    "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
                                }}>
                                {detalleCliente.mediosdecontactocliente.length > 0 &&
                                    <Tab label="Medios de Contacto" value="mediosContacto" />
                                }
                                {detalleCliente.apoderadoslegalescliente.length > 0 &&
                                    <Tab label="Apoderados legales" value="apoderados" />
                                }
                                {detalleCliente.representantesautorizadoscliente.length > 0 &&
                                    <Tab label="Personas Autorizadas" value="personasAutorizadas" />
                                }
                            </TabList>
                        </Box>
                        <TabPanel value="mediosContacto">
                            <div className='row'>
                                {ordenarActivosASC(sortJSON(mediosContacto, 'isbaja', 'asc'), 'medioscontacto')?.map((medio, index) =>
                                    <div key={index} className='col-12 col-md-4 mt-3'>
                                        <MediosContactoComponent data={medio} setIsEdicionmediosContacto={setIsEdicionmediosContacto} />
                                    </div>
                                )}
                            </div>

                        </TabPanel>
                        <TabPanel value="apoderados">
                            <div className='row'>
                                {ordenarActivosASC(sortJSON(apoderadosLegales, 'isbaja', 'asc'), 'apoderadoslegales')?.map((apoderado, index) =>
                                    <div key={index} className='col-12 col-md-4 mt-3'>
                                        <ApoderadosLegalesComponent data={apoderado} setIsEdicionApoderados={setIsEdicionApoderados} />
                                    </div>
                                )}
                            </div>
                        </TabPanel>
                        <TabPanel value="personasAutorizadas">
                            <div className='row'>
                                {ordenarActivosASC(sortJSON(personasAutorizadas, 'isbaja', 'asc'), 'personasautorizadas')?.map((persona, index) =>
                                    <div key={index} className='col-12 col-md-4 mt-3'>
                                        <PersonasAutorizadasComponent data={persona} setIsEdicionPersonas={setIsEdicionPersonas} />
                                    </div>
                                )}
                            </div>
                        </TabPanel>
                    </TabContext>
                </Box>
            }
        </Fragment>
    )

}

export default TabsDatosGeneralesComponent